/**
 * Centralized storage keys for session storage
 * Use these constants instead of hardcoded strings to ensure consistency
 */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
};

/**
 * Helper functions for token storage operations
 */
export const tokenStorage = {
  getToken: () => sessionStorage.getItem(STORAGE_KEYS.TOKEN),
  setToken: (token) => sessionStorage.setItem(STORAGE_KEYS.TOKEN, token),
  removeToken: () => sessionStorage.removeItem(STORAGE_KEYS.TOKEN),

  getRefreshToken: () => sessionStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
  setRefreshToken: (refreshToken) => sessionStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken),
  removeRefreshToken: () => sessionStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN),

  clearAll: () => {
    sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  },
};
